import {ComplianceManagerApi} from "../compliance-manager";
import ComplianceStatusButton from "../../compliance-status-button";
import {ComplianceSource} from "../../../../__generated__/graphql/types";

export default function ComplianceManagerOverallStatus(props: { api: ComplianceManagerApi }){
    const { paxContext } = props.api;

    return (
        <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
            <ComplianceStatusButton
                pax={paxContext}
                showSourcesTooltip={false}
                disabled
                style={{fontSize: '2rem', padding: 12, borderRadius: 12}}

            />
            <h3 style={{marginTop: 12}}>Overall Status</h3>
        </div>
    )
}